// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__28VLb","commentTextarea":"Footer_commentTextarea__1qyXo","buttons":"Footer_buttons__Cs6RX"};